import { ref, computed } from "vue";

/**
 * 画面表示に関わる UI 状態を管理する composable。
 *
 * @returns 画面で利用するリアクティブな状態オブジェクト
 */
export const useRegularDeliveryUiState = () => {
  // タブ状態
  const model = ref<number>(0);
  const mode = computed<"regist" | "list">(() =>
    model.value === 0 ? "regist" : "list"
  );
  const errdialog = ref<boolean>(false); //エラーダイアログ
  const errMessage = ref<string>(""); //エラーメッセージ
  const processFlag = ref<number>(0); //処理フラグ

  const panel = ref<number[]>([0]);

  //Loading
  const overlay = ref<boolean>(false);

  //ダイアログ初期化
  const confirmDeleteDialog = ref<boolean>(false);

  const dialog = ref<boolean>(false);
  const messagedialog = ref<boolean>(false); //エラーダイアログ
  const message = ref<string>(""); //エラーメッセージ
  const uploadDialog = ref<boolean>(false);
  const btnDisabled = ref<boolean>(false);

  /**
   * 出荷元店舗選択値
   */
  const shopSelectFromValues = ref<{ shop_code: string; name: string }>({
    shop_code: "",
    name: "",
  });

  /**
   * 配達先店舗選択値
   */
  const shopSelectToValues = ref<{ shop_code: string; name: string }>({
    shop_code: "",
    name: "",
  });

  /**
   * 定期配送登録設定タブ @Click
   */
  const onClickRegistTab = async (): Promise<void> => {
    model.value = 0;
    shopSelectFromValues.value = { shop_code: "", name: "" };
    shopSelectToValues.value = { shop_code: "", name: "" };
  };

  /**
   * 定期配送一覧タブ @Click
   */
  const onClickListTab = async (): Promise<void> => {
    model.value = 1;
    shopSelectFromValues.value = { shop_code: "", name: "" };
    shopSelectToValues.value = { shop_code: "", name: "" };
  };

  /**
   * 絞り込み条件パネル 開く
   */
  const openSearchPanel = (): void => {
    if (!panel.value.includes(0)) {
      panel.value.push(0);
    }
  };

  /**
   * 絞り込み条件パネル 閉じる
   */
  const closeSearchPanel = (): void => {
    panel.value = panel.value.filter((value) => value !== 0);
  };

  return {
    model,
    mode,
    errdialog,
    errMessage,
    processFlag,
    panel,
    overlay,
    confirmDeleteDialog,
    dialog,
    messagedialog,
    message,
    uploadDialog,
    btnDisabled,
    shopSelectFromValues,
    shopSelectToValues,
    onClickRegistTab,
    onClickListTab,
    openSearchPanel,
    closeSearchPanel,
  };
};
